import * as service from './service'
export default {
  namespace: 'recruitEntry',
  state: {
    recruitData: {},
    statusInvalid: false
  },
  effects: {
    * queryCourierRecruit ({ payload }, { call, put }) {
      const res = yield call(service.queryCourierRecruit, payload)
      yield put({
        type: 'save',
        payload: {
          recruitData: res.data.data || {}
        }
      })
      return res
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
